import "utils/dropConsole";
// antd framework style
import "antd/dist/antd.less";
// ROUTER
import { BrowserRouter } from "react-router-dom";
import { RouterConfig } from "navigation/RouterConfig";

import "./App.css";
import { ProvideAuth } from "navigation/Auth/ProvideAuth";
// Redux
import { Provider } from "react-redux";

import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import useVersionCheck from "hooks/useVersionCheck";

// Rendered inside BrowserRouter so useLocation (used by useVersionCheck) works
function VersionBanner() {
  const updateAvailable = useVersionCheck();
  if (!updateAvailable) return null;
  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: "#faad14",
      color: "#000",
      textAlign: "center",
      padding: "10px 16px",
      fontSize: 14,
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 12,
      boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
    }}>
      <span>⚠️ A new version of this site is available — please reload to avoid issues.</span>
      <button
        onClick={() => window.location.reload()}
        style={{
          background: "#000",
          color: "#fff",
          border: "none",
          borderRadius: 4,
          padding: "5px 16px",
          cursor: "pointer",
          fontWeight: 600,
          fontSize: 13,
          whiteSpace: "nowrap",
        }}
      >
        Reload Now
      </button>
    </div>
  );
}

function App() {
  return (
    <>
      <div>
        <Provider store={store}>
          <PersistGate persistor={persistor} loading={null}>
            <ProvideAuth>
              <BrowserRouter>
                <VersionBanner />
                <RouterConfig />
              </BrowserRouter>
            </ProvideAuth>
          </PersistGate>
        </Provider>
      </div>
    </>
  );
}

export default App;

